import { AppState } from 'reducers'

export const root = (state: AppState) => state.localisation

export const showLID = (state: AppState) => state.localisation.showLID

export const getTranslations = (state: AppState) =>
  state.localisation.translations

export default root
